import React from 'react';
import { Link } from 'react-router-dom';
import { Cell } from 'react-table';
import ShortTextControl from '../../../controls/short-text/short-text-control';

const shortTextFormatter = (
  cell: Cell,
  emptyObject: Record<string, never>,
  fullDisplay = false,
  numberOfChars = 5
): JSX.Element => {
  const row = cell.row.values;
  const addLink = row.destination === cell.value || row.source === cell.value;
  if (cell.value?.length <= 7 && !addLink) {
    return <span>{cell.value}</span>;
  }

  return addLink ? (
    <>
      <Link to={`/wallet/${row.destination === cell.value ? row.destination : row.source}`}>
        <ShortTextControl text={cell.value} numberOfChars={numberOfChars} fullDisplay={fullDisplay} />
      </Link>
      {row.source === cell.value && row.sourceUsername && <div>{row.sourceUsername}</div>}
      {row.destination === cell.value && row.destinationUsername && <div>{row.destinationUsername}</div>}
    </>
  ) : (
    <ShortTextControl text={cell.value} numberOfChars={numberOfChars} fullDisplay={fullDisplay} />
  );
};

export default shortTextFormatter;
